import { getErrorMessage } from "../../../../../helper/getResponseMessage";
import axios from "../../../../../util/axiosconfig";
import { SORT_FILTER } from "../../../../../util/constants";
import { showError } from "../../../../../util/ShowStatus";

export const fetchMyLeavesData = async (
  page: number,
  size: any,
  setMyLeavesData: any,
  setAvailableUsedLeaveData: any,
  setTotalRecords: any,
  setMyLeavesDataLoading: any,
  filters: any,
  sortFilter: any,
  toast: any
) => {
  try {
    const params: any = {
      page,
      size,
      sortField: sortFilter.sortField,
      sortOrder:
        sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
    };
    if (filters) {
      if (filters.leaveType) {
        params.leaveTypeID = filters.leaveType.id;
      }
      if (filters.status) {
        params.status = filters.status;
      }
      if (filters.startDate) {
        params.startDate = filters.startDate;
      }
      if (filters.endDate) {
        params.endDate = filters.endDate;
      }
    }
    setMyLeavesDataLoading(true);
    const response = await axios.get(`tl-user-leave/my-leave`, { params });
    setMyLeavesData(response.data.result);
    setAvailableUsedLeaveData({
      availableLeaves: response.data.available_leaves,
      usedLeaves: response.data.used_leaves,
      pendingLeaves: response.data.pending_leave,
      holidayCount: response.data.holiday_count,
    });
    setTotalRecords(response.data.totalRecords);
    setMyLeavesDataLoading(false);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    setMyLeavesDataLoading(false);
    showError(errorMessage, toast);
  }
};

export const fetchLeaveTypes = async (setLeaveTypes: any, toast: any) => {
  try {
    const response = await axios.get("tl-user-leave/list-leave-type");
    setLeaveTypes(response.data.result);
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    showError(errorMessage, toast);
  }
};

export const fetchDepartments = async (setDepartments: any, toast: any) => {
  try {
    const response = await axios.get("tl-admin/department/all?page=-1");
    setDepartments(response.data.result);
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};
